import { ServerPlusIcon } from './ServerPlusIcon';

/**
 * author: Austin Andrews
 * id 99AC1D59-A2F0-4B53-872D-0374D0804E0A
 * name server-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/server-plus.svg
 * tags
 */
export const ServerAddIcon = ServerPlusIcon;
export default ServerAddIcon